import toLower from 'lodash/toLower';
import React, { FC } from 'react';
import SelectionBulkMenu from '../../../shared/components/SelectionBulkMenu';
import BreadCrumbNav from '../../../shared/navigation/BreadcrumbNav';
import SelectionBulkContainer from '../../../shop/selectionlists/header/SelectionBulkContainer';
import { useTranslation } from 'react-i18next';
import { BulkAddProductsToSelectionListResponse, BulkAddProductsToShoppingCartResponse } from '../../../store/api';
import { SelectionList } from '../../../../models/SelectionList';
import { PriceTier } from '../../../../models/PriceTier';
import { SubscriptionPeriodType } from '../../../../models/Article';
import { BreadcrumbsState } from '../../../shared/breadcrumbs/types';
import { useStickyHeader } from '../../../shared/header/useStickyHeader';

interface Props {
    isInSelectionMode: boolean;
    loanFormat: {
        key: string;
        name: string;
        icon: string;
    };
    cancelSelection: () => void;
    productSelectionCount: number;
    onBulkAddToCart: (
        performChecks: boolean,
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType
    ) => Promise<BulkAddProductsToShoppingCartResponse>;
    onBulkAddToList: (
        list: SelectionList,
        performChecks: boolean,
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType
    ) => Promise<BulkAddProductsToSelectionListResponse>;
    onBulkAddToGroup: (productGroupId: number) => void;
    breadcrumbs: BreadcrumbsState;
    topGenre?: string;
    queryParamString: string;
    containsEpressProducts: boolean;
    isNothingSelected: boolean;
    hasSingleUsageCondition: boolean;
}

export const CollectionByGenreHeader: FC<Props> = ({
    loanFormat,
    isInSelectionMode,
    cancelSelection,
    productSelectionCount,
    onBulkAddToCart,
    onBulkAddToList,
    onBulkAddToGroup,
    containsEpressProducts,
    isNothingSelected,
    hasSingleUsageCondition,
    breadcrumbs,
    queryParamString
}) => {
    const customGenreBase = `by-genre/${toLower(loanFormat.key)}`;
    const { t } = useTranslation();
    const { isSticky } = useStickyHeader();

    const bulkMenu = (
        <SelectionBulkMenu
            isInSelectionMode={isInSelectionMode}
            cancelSelection={cancelSelection}
            selectedCount={productSelectionCount}
            onBulkAddToCart={onBulkAddToCart}
            onBulkAddToList={onBulkAddToList}
            onBulkAddToGroup={onBulkAddToGroup}
            deleteLabel={t('deleteFromList')}
            isAddToCartEnabled={true}
            isAddToListEnabled={true}
            showSubscriptionStartDateOption={containsEpressProducts}
            isAddToProductGroupEnabled
            isNothingSelected={isNothingSelected}
            hasSingleUsageCondition={hasSingleUsageCondition}
        />
    );

    const header = (
        <div className="by-genre-header">
            <BreadCrumbNav
                loanFormat={loanFormat}
                breadcrumbs={breadcrumbs}
                fixedLabel={t('components.genreSidebar.genres')}
                path="collection"
                customGenreBase={customGenreBase}
                queryParamString={queryParamString}
                floatingClass=""
            />
        </div>
    );

    return (
        <SelectionBulkContainer
            movedUp={isInSelectionMode}
            isSticky={isSticky}
            headerComponent={header}
            bulkMenuComponent={bulkMenu}
            headerHeight={64}
        />
    );
};
